export default function StepHeader({
  step,
  title,
  desc,
}: {
  step: number;
  title: string;
  desc: string;
}) {
  return (
    <div className="mb-10">
      <div className="flex items-center gap-4 mb-2">
        <span className="flex items-center justify-center w-10 h-10 rounded-full bg-ca-accent text-ca-brand font-black text-lg">
          {step}
        </span>
        <h2 className="text-3xl font-black text-ca-surface-ink tracking-tight uppercase">
          {title}
        </h2>
      </div>
      <p className="text-ca-surface-muted ml-14 font-medium">{desc}</p>
    </div>
  );
}
